export const confirmContactDetails = {
  title: {
    en: 'Sorry, we cannot show online banking',
    nb: 'Beklager, vi kan ikke vise nettbank',
    nn: 'Beklager, vi kan ikkje vise nettbank',
  },
  message: {
    en: 'Confirm your contact information to access online banking.',
    nb: 'Bekreft kontaktinformasjonen din for å få tilgang til nettbank.',
    nn: 'Stadfest kontaktinformasjonen din for å få tilgang til nettbank.',
  },
  suggestionsTitle: {
    en: 'You can confirm your contact information',
    nb: 'Du kan bekrefte kontaktinformasjonen din',
    nn: 'Du kan stadfeste kontaktinformasjonen din',
  },
  profilePrefix: {
    en: 'on',
    nb: 'på',
    nn: 'på',
  },
  profileLinkText: {
    en: 'My profile under Menu',
    nb: 'Min profil under Meny',
    nn: 'Min profil under Meny',
  },
  homePrefix: {
    en: 'on',
    nb: 'på',
    nn: 'på',
  },
  homeLinkText: {
    en: 'the home page on My page',
    nb: 'forsiden på Min side',
    nn: 'framsida på Min side',
  },
  contactInfoPrefix: {
    en: 'If you still have problems, you can contact us at',
    nb: 'Hvis du fortsatt har problemer kan du kontakte oss på',
    nn: 'Hvis du framleis har problem kan du kontakte oss på',
  },
  goToProfileButton: {
    en: 'Go to My profile',
    nb: 'Gå til Min Profil',
    nn: 'Gå til Min Profil',
  },
  goToHomeButton: {
    en: 'Go to My page',
    nb: 'Gå til Min side',
    nn: 'Gå til Min side',
  },
} as const;
